const actions = {
  SET_APP: "SET_APP",
  SET_PHONE_AUTH_CONFIRMATION_RESULT: "SET_PHONE_AUTH_CONFIRMATION_RESULT",
  SET_CORPORATE_ID: "SET_CORPORATE_ID",
  SET_PHONE_NUMBER: "SET_PHONE_NUMBER",
};

export default actions;
